import streamSaver from 'streamsaver'

streamSaver.mitm = `${process.env.PUBLIC_URL}/streamSaver/mitm.html`

export default streamSaver
